import { render } from "./UpdateAvatar.vue?vue&type=template&id=167ae5c6&scoped=true"
import script from "./UpdateAvatar.vue?vue&type=script&lang=js"
export * from "./UpdateAvatar.vue?vue&type=script&lang=js"

import "./UpdateAvatar.vue?vue&type=style&index=0&id=167ae5c6&lang=scss&scoped=true"
import "./UpdateAvatar.vue?vue&type=style&index=1&id=167ae5c6&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167ae5c6"]])

export default __exports__